import { render, staticRenderFns } from "./unpin.vue?vue&type=template&id=55bbea69"
import script from "./unpin.vue?vue&type=script&lang=js"
export * from "./unpin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports